import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import PaginationAdvanced from "../components/PaginationAdvanced";
import { CSSTransitionGroup } from 'react-transition-group';
import Joyride from "react-joyride";
import CompanyStatusCheck from "./CompanyStatusCheck";
import Search from "./Search";
import * as Constants from '../constants';

import Index from "./Index";
import { fetchCampaigns } from "../actions/index";
import CampaignsIndexTourSteps from "./tours/CampaignsIndexTourSteps";

export class CampaignsIndex extends Index {
  static propTypes = {
    fetchCampaigns: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    campaigns: PropTypes.object,
  };

  constructor(props) {
    super(props);
  }

  fetchData() {
    let newQueries = {
        page: this.state.page || 1,
        per_page: this.state.per_page || "",
        search: this.state.search || "",
        category: this.state.category || "",
        sort: this.state.sort || "",
        direction: this.state.direction || ""
      };
    this.props.fetchCampaigns(
      this.serialize(newQueries)
    );
    this.props.history.push(`/campaigns/${this.serialize(newQueries)}`);
  }

  renderCampaigns() {
    if (!this.props.campaigns.data) {
      return (
        <tr>
          <td colSpan={14}>
            <div className="vertical-center">
              <CSSTransitionGroup
                transitionName="spinner"
                transitionAppear={true}
                transitionAppearTimeout={500}
              >
                <i className="fa fa-refresh fa-4x fa-spin" />
              </CSSTransitionGroup>
            </div>
          </td>
        </tr>
      );
    } else if (this.props.campaigns.data.length == 0) {
      return (
        <tr>
          <td colSpan={14}>
            <div className="well well-lg text-center">
              You have no active campaigns.&nbsp;
              <Link
                to={`/campaigns/new`}
                className=""
              >
                Click here to create one.
              </Link>
            </div>
          </td>
        </tr>
      );
    }

    return this.props.campaigns.data.map(campaign => {
      let statusLabel =
        campaign.status == "Active" ? "label-success" : "label-default";
      return (
        <tr key={campaign.id}>
          <td>
            <Link
              to={`/campaigns/${
                campaign.id
              }`}
            >
              <strong>{campaign.name}</strong>
            </Link>
          </td>
          <td className="text-center">
            <span className={`label ${statusLabel}`}>{campaign.status}</span>
          </td>
          <td className="text-right">{campaign.step_count}</td>
          <td className="text-right">
            <Link
              to={`/campaigns/${
                campaign.id
              }/subscriptions?${Constants.DEFAULT_PAGINATION}`}
            >
              {campaign.subscription_count}
            </Link>
          </td>
          <td className="text-right">
            {campaign.delivered_count > campaign.sent_emails_count
              ? campaign.delivered_count
              : campaign.sent_emails_count}
          </td>
          <td className="text-right">{campaign.delivered_count}</td>
          <td className="text-right">{campaign.opened_count}</td>
          <td className="text-right">{campaign.clicked_count}</td>
          <td className="text-right">{campaign.unsubscribed_count}</td>
          <td className="text-right">{campaign.complained_count}</td>
          <td className="text-right">{campaign.bounced_count}</td>
          <td className="text-right">{campaign.dropped_count}</td>
          <td className="text-right">{campaign.sent_sms_count}</td>
          <td className="text-right">
            <Link
              to={`/campaigns/${
                campaign.id
              }`}
              className="btn btn-sm btn-default campaign_edit"
            >
              Edit
            </Link>
            <Link
              to={`/campaigns/${
                campaign.id
              }/emails?${Constants.DEFAULT_PAGINATION}`}
              className="btn btn-sm btn-default campaign_emails m-l-5"
            >
              Emails
            </Link>
            <Link
              to={`/campaigns/${
                campaign.id
              }/sms?${Constants.DEFAULT_PAGINATION}`}
              className="btn btn-sm btn-default campaign_sms m-l-5"
            >
              SMS
            </Link>
            <Link
              to={`/${this.props.match.params.site_uuid}/campaigns/${
                campaign.id
              }/rvms?${Constants.DEFAULT_PAGINATION}`}
              className={`btn btn-sm btn-default campaign_postcards m-l-5 ${
                Constants.BETA_SITE_UUIDS.includes(localStorage.getItem('lastSiteUUID')) ? "" : "hide"
              }`}
            >
              VMs
            </Link>
            <Link
              to={`/campaigns/${
                campaign.id
              }/postcards?${Constants.DEFAULT_PAGINATION}`}
              className="btn btn-sm btn-default campaign_postcards m-l-5 hide"
            >
              Postcards
            </Link>
          </td>
        </tr>
      );
    });
  }

  startTour() {
    this.setState({
      steps: CampaignsIndexTourSteps.tourSteps(),
      startTour: true
    });
  }

  render() {
    let count = 0;
    if (!this.props.campaigns) {
      return (
        <div>
          <CompanyStatusCheck history={this.props.history} />
        </div>
      );
    }
    if (this.props.campaigns.meta) {
      count = this.props.campaigns.meta.count;
    }
    return (
      <div className="campaigns_index">
        <CompanyStatusCheck history={this.props.history} />
        <Joyride
          run={this.state.startTour}
          continuous={true}
          steps={this.state.steps}
          showSkipButton={true}
          showProgress={true}
          scrollToSteps={false}
          callback={this.tourCallback.bind(this)}
        />
        <div className="row">
          <h1>
            Workflows
            <button
              bsStyle="default"
              className="btn btn-sm btn-primary help_icon_smaller"
              onClick={this.startTour.bind(this)}
            >
              ?
            </button>
            <Link
              to={`/campaigns/new`}
              className="btn btn-primary pull-right new_campaign_btn m-l-10"
            >
              Add a Workflow
            </Link>
            <div className="pull-right">
              <Search
                handleSearch={this.handleSearch.bind(this)}
                searchStr={this.state.search}
              />
            </div>
          </h1>
        </div>
        <div className="row">
          <table className="table table-striped">
            <thead>
              <tr>
                <th
                  className={`campaign_name ${this.indicateSorting("name")}`}
                  data-sort="name"
                  onClick={this.handleOrder.bind(this)}
                >
                  Name
                </th>
                <th
                  className={`text-center campaign_status ${this.indicateSorting(
                    "status"
                  )}`}
                  data-sort="status"
                  onClick={this.handleOrder.bind(this)}
                >
                  Status
                </th>
                <th className="text-right campaign_steps">Steps</th>
                <th className="text-right campaign_leads">Leads</th>
                <th
                  className={`text-right campaign_email_stats_queued ${this.indicateSorting(
                    "sent_emails_count"
                  )}`}
                  data-sort="sent_emails_count"
                  onClick={this.handleOrder.bind(this)}
                >
                  Sent
                </th>
                <th
                  className={`text-right campaign_email_stats_delivered ${this.indicateSorting(
                    "delivered_count"
                  )}`}
                  data-sort="delivered_count"
                  onClick={this.handleOrder.bind(this)}
                >
                  Delivered
                </th>
                <th
                  className={`text-right campaign_email_stats_opened ${this.indicateSorting(
                    "opened_count"
                  )}`}
                  data-sort="opened_count"
                  onClick={this.handleOrder.bind(this)}
                >
                  Opens
                </th>
                <th
                  className={`text-right campaign_email_stats_clicked ${this.indicateSorting(
                    "clicked_count"
                  )}`}
                  data-sort="clicked_count"
                  onClick={this.handleOrder.bind(this)}
                >
                  Clicks
                </th>
                <th
                  className={`text-right campaign_email_stats_unsubscribed ${this.indicateSorting(
                    "unsubscribed_count"
                  )}`}
                  data-sort="unsubscribed_count"
                  onClick={this.handleOrder.bind(this)}
                >
                  Unsubs
                </th>
                <th
                  className={`text-right campaign_email_stats_spam_report ${this.indicateSorting(
                    "complained_count"
                  )}`}
                  data-sort="complained_count"
                  onClick={this.handleOrder.bind(this)}
                >
                  Spam R.
                </th>
                <th
                  className={`text-right campaign_email_stats_bounced ${this.indicateSorting(
                    "bounced_count"
                  )}`}
                  data-sort="bounced_count"
                  onClick={this.handleOrder.bind(this)}
                >
                  Bounces
                </th>
                <th
                  className={`text-right campaign_email_stats_failed ${this.indicateSorting(
                    "dropped_count"
                  )}`}
                  data-sort="dropped_count"
                  onClick={this.handleOrder.bind(this)}
                >
                  Failures
                </th>
                <th
                  className={`text-right campaign_sent_sms_count ${this.indicateSorting(
                    "sent_sms_count"
                  )}`}
                  data-sort="sent_sms_count"
                  onClick={this.handleOrder.bind(this)}
                >
                  SMS
                </th>
                <th className="text-right" />
              </tr>
            </thead>
            <tbody>{this.renderCampaigns()}</tbody>
          </table>
        </div>
        <div className="row text-right">
          <PaginationAdvanced
            handle={this.handlePagination.bind(this)}
            total={count}
            page={this.state.page}
            per_page={this.state.per_page}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { campaigns: state.campaigns.all };
}

export default connect(
  mapStateToProps,
  { fetchCampaigns }
)(CampaignsIndex);
